/* eslint class-methods-use-this: "off", no-param-reassign: "off" */
import CollectionModule from 'client/store/modules/CollectionModule';
import SystemPolicyStatusApi from 'client/api/v2/SystemPolicyStatusApi';

class SystemPolicyStatusCollection extends CollectionModule {
  /**
   * Override method from base class to add policies specific fields to the Vuex
   * module entities and features.
   */
  extractModule() {
    const module = super.extractModule();

    module.actions.setSystemId = (...params) => this.setSystemId(...params);
    module.actions.fetchFilteredTotalCount = (...params) => this.fetchFilteredTotalCount(...params);

    return module;
  }
  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  getInitialState() {
    return super.getInitialState();
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  // this gets a filtered total count that removes any "failed to install" duplicate status values
  async fetchFilteredTotalCount() {
    // filter to get "failed to install" status results
    const failedStatusFilter = [
      {
        name: 'state',
        operator: 'eq',
        value: 'FAILED',
      },
    ];

    const failedStatusItems = await this.Api.fetchAll('', '', failedStatusFilter);
    const boundPolicies = await this.Api.getSystemBoundPolicies();

    // we want to subtract the amount of unbound duplicate policy results
    const unboundFailedDuplicateCount = failedStatusItems.reduce(
      (count, item) => {
        const isDuplicate = item.stdErr.includes('Duplicate');
        const isUnbound = !boundPolicies.results
          .find(boundPolicy => boundPolicy.id === item.policyID);

        return isDuplicate && isUnbound ? count + 1 : count;
      }, 0,
    );

    const totalCount = await this.Api.fetchTotalCount();

    return totalCount - unboundFailedDuplicateCount;
  }

  setSystemId(context, systemId) {
    this.Api.setSystemId(systemId);
  }
}

export default new SystemPolicyStatusCollection(SystemPolicyStatusApi, 'id', '').extractModule();

// Export class so that private methods used by actions can be tested!
export const SystemPolicyStatusCollectionClass = SystemPolicyStatusCollection;
